import React, { useState } from 'react';
import { Box, Stack, Popover, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import AvatarComponentProps from '../../../types/Avatar.type';
import './AvatarComponent.scss';

const AvatarComponent: React.FC<AvatarComponentProps> = ({
  name,
  designation,
  className,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div className={className} data-testid="avatar-container"> {/* Apply the className here */}
      <motion.div
        whileHover={{
          scale: 1.2,
        }}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <Box
          component="button"
          width={35}
          height={35}
          border="none"
          borderRadius={10}
          bgcolor="#0074CA"
          textAlign="center"
          color={'#fff'}
          p="0.1rem"
          fontWeight="bold"
          fontSize={14}
          data-testid="small-avatar"
        >
          {(name?.charAt?.(0)?.toUpperCase() ?? '') + (name?.split(' ')?.[1]?.charAt(0)?.toUpperCase() ?? '')}
        </Box>
      </motion.div>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none',
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Stack
          direction="row"
          alignItems="center"
          textAlign="center"
          spacing={2}
          maxWidth="350px"
          flexWrap="wrap"
          p={2}
        >
          <Box
            component="button"
            minWidth={70}
            minHeight={70}
            border="none"
            borderRadius={20}
            bgcolor="#0074CA"
            color="#fff"
            p="0.2rem"
            mb={1}
            fontSize={30}
            fontWeight="bold"
          >
            {name?.split(' ')?.[0]?.charAt(0)?.toUpperCase() ?? ''}
            {name?.split(' ')?.[1]?.charAt(0)?.toUpperCase() ?? ''}
          </Box>
          <Stack textAlign="left" gap={1} id="user-details">
            <Typography variant="h6">{name}</Typography>
            <Typography variant="body2">{designation}</Typography>
          </Stack>
        </Stack>
      </Popover>
    </div>
  );
};

export default AvatarComponent;
